var _rect, _path, _rect2, _rect3, _path2, _rect4, _rect5, _path3, _rect6, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMsExcel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1.25,
    width: 15,
    height: 17.5,
    rx: 2,
    fill: "#2FB776"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.375H20V16.75C20 17.8546 19.1046 18.75 18 18.75H7C5.89543 18.75 5 17.8546 5 16.75V14.375Z",
    fill: "url(#paint0_linear_1240_639)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 10,
    width: 7.5,
    height: 4.375,
    fill: "#229C5B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 5.625,
    width: 7.5,
    height: 4.375,
    fill: "#27AE68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.25C5 2.14543 5.89543 1.25 7 1.25H12.5V5.625H5V3.25Z",
    fill: "#1D854F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5.625,
    width: 7.5,
    height: 4.375,
    fill: "#197B43"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 7.5,
    height: 4.375,
    fill: "#1B5B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.625C5 6.96815 6.34315 5.625 8 5.625H9.5C11.1569 5.625 12.5 6.96815 12.5 8.625V13.875C12.5 15.5319 11.1569 16.875 9.5 16.875H5V8.625Z",
    fill: "black",
    fillOpacity: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 4.375,
    width: 11.25,
    height: 11.25,
    rx: 2,
    fill: "url(#paint1_linear_1240_639)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 13.125L6.36383 9.9375L8.04768 6.875H6.67311L5.63359 8.83036L4.61125 6.875H3.19373L4.88617 9.9375L3.125 13.125H4.49957L5.60782 11.0536L6.70747 13.125H8.125Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1240_639",
    x1: 5,
    y1: 16.5625,
    x2: 20,
    y2: 16.5625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#163C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1240_639",
    x1: 0,
    y1: 10,
    x2: 11.25,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176F3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsExcel);
export default __webpack_public_path__ + "static/media/ms_excel.6866eb070b2404c2252598790fe9bc15.svg";
export { ForwardRef as ReactComponent };